export const projectName = "Crypto Bird";
export const contractAddress = "0x99bebd7112CEdB602147385C0085Fd91859a0C64";
export const opensea = "crypto-bird-by-gotdik";
export const twitter = "CryptoBirdGD";
export const supply = 1111;
